<template>
  <div>
    <button class="refonte_btn-primary buildPdfBtn" @click="Synthesis()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" width="20" height="20" aria-hidden="true"><path d="M352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 306.7L246.6 265.3C234.1 252.8 213.8 252.8 201.3 265.3C188.8 277.8 188.8 298.1 201.3 310.6L297.3 406.6C309.8 419.1 330.1 419.1 342.6 406.6L438.6 310.6C451.1 298.1 451.1 277.8 438.6 265.3C426.1 252.8 405.8 252.8 393.3 265.3L352 306.7L352 96zM160 384C124.7 384 96 412.7 96 448L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 448C544 412.7 515.3 384 480 384L433.1 384L376.5 440.6C345.3 471.8 294.6 471.8 263.4 440.6L206.9 384L160 384zM464 440C477.3 440 488 450.7 488 464C488 477.3 477.3 488 464 488C450.7 488 440 477.3 440 464C440 450.7 450.7 440 464 440z"/></svg>
      <span class="pdf-btn-name" v-html="$t('views.synthesisView.downloadSynthesis.btn')"></span>
    </button>

    <b-modal
      content-class="mymodalContent"
      modal-class="mymodal"
      id="downloadSynthesis"
      size="lg"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-div">
        <h2 v-html="$t('views.synthesisView.downloadSynthesis.popin.title')"></h2>
        <div class="editorial" v-html="$t('views.synthesisView.downloadSynthesis.popin.text')"></div>
        <div class="popin-actions">
          <b-button class="popin-btn-cancel" @click="$bvModal.hide('downloadSynthesis')">
            <cancel-icon title />
            {{
            $t("views.synthesisView.downloadSynthesis.popin.btnCancel")
            }}
          </b-button>
          <b-button class="refonte_btn-primary popin-btn-confirm" @click="downloadSynthesis()">
            <download-icon title />
            {{
            $t("views.synthesisView.downloadSynthesis.popin.btnDownload")
            }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      content-class="mymodalContent"
      modal-class="mymodal"
      id="waiting"
      size="lg"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-div">
        <div class="spinner">
          <h2
            v-html="
              $t('views.synthesisView.downloadSynthesis.popin.waitingTitle')
            "
          ></h2>
          <p
            v-html="
              $t('views.synthesisView.downloadSynthesis.popin.waitingText')
            "
          ></p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { saveAs } from "file-saver";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import DownloadIcon from "vue-material-design-icons/Download.vue";
import FilePdfIcon from "vue-material-design-icons/FilePdf.vue";

export default {
  name: "GeneratePdf",
  components: {
    CancelIcon,
    DownloadIcon,
    FilePdfIcon
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    }
  },
  data: function() {
    return {
      showSpinner: false
    };
  },
  methods: {
    downloadSynthesis: function() {
      var that = this;

      // on cache la popin de demande de téléchargement
      this.$bvModal.hide("downloadSynthesis");

      // on affiche la popin avec le spinner qui permet de faire patienter l'utilisateur dans le cas où le serveur prend du temps à répondre
      this.$bvModal.show("waiting");

      if (this.$store.state.appState.urls.URL_GetPDF == "STUB") {
        setTimeout(function() {
          alert("La génération PDF n'est pas disponible dans le prototype.");
          that.$bvModal.hide("waiting");
        }, 
        250);
        return;
      }

      var data = this.gpsst;

      // envoi la data construite au backend afin de réception le pdf à télécharger
      axios
        .post(this.$store.state.appState.urls.URL_GetPDF, data, {
          headers: { "content-type": "application/json; charset=UTF-8" },
          responseType: "blob",
          timeout: 30000
        })
        .then(function(response) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const fileName = that.$i18n.t("global.pdfFileTitle");
          saveAs(blob, fileName);
        })
        .catch(function(error) {
          // si l'URL n'est pas accessbile, on récupères les textes liés à cette erreur
          that.$store.commit("SET_ERROR", {
            title: that.$i18n.t("global.error.title"),
            text: that.$i18n.t(
              "views.synthesisView.downloadSynthesis.popin.error404"
            )
          });
          that.$bvModal.show("error"); // on affiche la popin qui permet alors d'indiquer l'erreur à l'utilisateur
          if (that.$store.state.appState.env === "DEV") {
            // dans le cas où on est en dev, on affiche l'erreur dans la console.
            console.error("impossible de charger le PDF de la synthèse", error);
          }
        })
        .finally(function() {
          // dans tous les cas on cache la popin affichant le spinner "waiting" à la fin de l'exécution de la requête
          that.$bvModal.hide("waiting");
        });
    },
    Synthesis: function() {
        dataLayer.push({
            'event': 'etools.interaction',
            'etool_action': 'Télécharger la synthèse (PDF)',
            'etool_name': 'Outil GPSST',
            'etool_step': 'Fin',
            'document_type': 'PDF'
        });
        this.$bvModal.show("downloadSynthesis");
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"

.buildPdfBtn
  font-weight: bold
  font-size: 1.3em
  margin: 0.5em 0

.spinner
  padding: 0 85px 0 0
  background: url(../../../public/icons/loading.gif) 100% 50% no-repeat
  min-height: 64px

.modal-div
  ::v-deep .editorial
    margin: 1em 0 2em 0

</style>